import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";
import _ from "underscore"

const styles = StyleSheet.create({
    page: {
        padding: 10
    },
    container: {
        displat: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    mainResultContainer: {
        alignItems: 'center',
        backgroundColor: '292c34',
        color: 'white'
    },
    resultContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderRadius: 5,
        padding: 10,
        fontSize: 12,
        width: 400
    },
    rightText: {
        // backgroundColor: 'green',
        color: 'red'
    },
    leftText: {
        // backgroundColor: 'blue',
    }
});

export function PdfDocument({input, result, output, data}) {
    console.log("pdf props", input);
    console.log("pdf props", result);
    console.log("pdf props", output);
    console.log("pdf props", data);
    return (
        <Document>
            <Page style={styles.page}>
                <View style={styles.container}>
                    <Text>Input X-Ray</Text>
                    <Image
                        source={input}
                    />
                    <View style={styles.mainResultContainer}>
                    {_.map(result, (val, key) => (
                        <View style={styles.resultContainer}>
                            <Text style={styles.leftText}>{key} - </Text>
                            <Text style={styles.rightText}>{Math.round((val + Number.EPSILON) * 100) / 100} %</Text>
                        </View>
                    ))}
                    </View>
                    <Text>Heatmap X-Ray</Text>
                    <Image
                        src={output}
                    />
                    <View style={styles.mainResultContainer} break>
                        <Text>Patient Information(Doctor input)</Text>
                        {_.map(data, (val, key) => (
                        <View style={styles.resultContainer}>
                            <Text style={styles.leftText}>{key} - </Text>
                            <Text style={styles.rightText}>{val}</Text>
                        </View>
                        ))}
                    </View>
                </View>
            </Page>
        </Document>
    );
}
